import { useAppContext } from "@context/app";
import { segmentEvent } from "@utils/segment";

import { useRouter } from "next/router";
import { ISourceEvent } from "./useEvents";

function useEGamingBrandViewed() {
    const { user, country } = useAppContext();
    const { locale } = useRouter();

    const eGamingBrandListingViewed = (source: ISourceEvent) => {
        segmentEvent("EGaming Brand Listing Viewed", {
            user_id: user.data?.id || -1,
            country_id: country?.id,
            country_slug: country?.slug,
            language: locale?.includes("en") ? "English" : "Arabic",
            ...source,
        });
    };

    return { eGamingBrandListingViewed };
}

export default useEGamingBrandViewed;

